import axios from 'axios';

import settings from '../libs/config';
import ApiError from './apiError.js';

const endpoint = settings.api_host + "/user";

const apiRegister = async (userData) => {

	let { email, password, age, gender, zipcode, firstname, lastname, provider } = userData;

	if (!email) {
		throw new Error("Missing email");
	}
	if (!password) {
		throw new Error("Missing password");
	}
	if (!age) {
		throw new Error("Missing age");
	}
	if (!gender) {
		throw new Error("Missing gender");
	}
	if (!zipcode) {
		throw new Error("Missing zipcode");
	}
	if (!firstname) {
		throw new Error("Missing firstname");
	}
	if (!lastname) {
		throw new Error("Missing lastname");
	}
	if (!provider) {
		throw new Error("Missing provider");
	}

	try {
		const response = await axios.post(endpoint, userData);

		const data = response.data;
		return data.result;
	} catch (error) {
		throw new ApiError(error);
	}
};

export default apiRegister;


// WEBPACK FOOTER //
// ./src/api/register.js